import React from 'react';
import { googleLoginUrl } from '../services/api';

const LoginPage = ({ config, onDevLogin, search = window.location.search }) => {
  const params = new URLSearchParams(search);
  const error = params.get('error');
  let message = null;
  if (error === 'not_allowed') message = "This Google account isn't allowed.";
  if (error === 'oauth') message = "Sign-in didn't complete.";
  if (!config.googleConfigured && !config.devBypass) {
    message = "Google sign-in isn't configured yet.";
  }

  return (
    <div className="min-h-screen bg-[#07080d] text-zinc-100 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_20%,#12303a_0%,#07080d_55%)]" />
      <div className="relative w-full max-w-md rounded-2xl border border-cyan-400/20 bg-[#0b0d14]/90 p-10 text-center shadow-[0_0_40px_rgba(34,211,238,0.08)]">
        <p className="text-xs tracking-[0.2em] text-teal-300 font-mono">SHOWME.TIPS</p>
        <p className="mt-3 text-sm text-zinc-500">Personal systems · authorized only</p>
        {message && <p className="mt-4 text-sm text-rose-400">{message}</p>}
        {config.googleConfigured && (
          <a
            href={googleLoginUrl()}
            className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-white px-4 py-3 text-sm font-semibold text-zinc-900"
          >
            Continue with Google
          </a>
        )}
        {config.devBypass && (
          <button
            type="button"
            onClick={onDevLogin}
            className="mt-8 inline-flex w-full items-center justify-center rounded-lg border border-cyan-400/40 px-4 py-3 text-sm font-semibold text-teal-200"
          >
            Dev enter
          </button>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
